import * as React from 'react';
import { Field, InjectedFormProps } from 'redux-form';

import { withIntl, IntlProps } from 'ha/i18n';
import { withStyles, Theme, WithStyles, createStyles } from '@material-ui/core';

import units from 'ha/theme/units';
import Grid from 'ha/ui/next/Grid';
import ListingDateRangeInput from 'ha/components/FormFields/ListingDateRangeInput';
import Track from 'ha/components/track/SmartTrack';
import Button from 'ha/ui/next/Button';
import getToday from 'ha/helpers/hadate/getToday';
import { RenderInputsProps } from 'ha/ui/DateRangeInput';

import DateRangePickerInputs from './DateRangePickerInputs';
import LocationsInput from '../../containers/SearchBar/LocationsInput';

export const styles = (theme: Theme) =>
  createStyles({
    container: {
      padding: units.yx(0.25, 0.5),
    },
    button: {
      background: 'linear-gradient(to right, #b56da8, #8e5082)',
      boxShadow: 'inherit',
      '&:hover': {
        boxShadow: '0 2px 9px 0 rgba(146, 83, 134, 0.35)',
      },
      height: units.rem(3.5),
      fontSize: units.rem(1.125),
      fontWeight: 'bold',
    },
  });

export interface FormValues {
  place: string;
  dateRange: {
    startDate?: string | null;
    endDate?: string | null;
  };
}

interface Props {
  className?: string;
  form: {
    handleSubmit: () => void;
    submitting: boolean;
  };
  formValues: FormValues;
}

export type SearchBarProps = Props & IntlProps & InjectedFormProps<FormValues>;

export const SearchBar: React.SFC<
  SearchBarProps & WithStyles<typeof styles>
> = ({
  form: { handleSubmit, submitting },
  intl: { T },
  formValues,
  classes,
}) => (
  <form onSubmit={handleSubmit}>
    <Grid container spacing={8} className={classes.container}>
      <Grid item xs={12} md={6}>
        <Field
          name="place"
          id="place"
          component={LocationsInput}
          placeholder={T('Where will you go?')}
          predictionTypes={['(cities)']}
        />
      </Grid>

      <Grid item xs={12} md={4}>
        <Field
          name="dateRange"
          minimumDate={getToday()}
          component={ListingDateRangeInput}
          renderInputs={(props: RenderInputsProps) => (
            <DateRangePickerInputs {...props} />
          )}
        />
      </Grid>

      <Grid item xs={12} md={2}>
        <Track
          name="Clicked Search button"
          type="button"
          getDynamicData={() => formValues}
        >
          <Button
            disabled={submitting}
            type="submit"
            fullWidth
            data-test-locator="Search and book"
            variant="contained"
            color="primary"
            classes={{
              root: classes.button,
            }}
          >
            {T('Search')}
          </Button>
        </Track>
      </Grid>
    </Grid>
  </form>
);

export default withStyles(styles)(withIntl(SearchBar));
